/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Permission_Filter_AllInputs */

const fr_permission_filter_all = /** @type {(inputs: Permission_Filter_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tous`)
};

/**

* @param {Permission_Filter_AllInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const permission_filter_all = /** @type {((inputs?: Permission_Filter_AllInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Permission_Filter_AllInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_permission_filter_all(inputs)
});